module.exports = __webpack_public_path__ + "media/newsletter_page/img1-047d94f6.png";